<template>
  <div class="pastable" pastable @click="click" :class="{ pastablefocus: isFocusable }">
    <div v-show="!readonly">{{message}}</div>
    <div ref="container" @focus="focus" @blur="blur" @paste="paste" contenteditable="true" aria-hidden="true" tabindex="-1" style="width: 1px; height: 1px; position: fixed; left: -100px; overflow: hidden; opacity: 1e-17"></div>
    <div class="image-block" v-for="img in imgs" :key="img.src">
      <span style="display:block;text-align: right;"><i v-show="!readonly" class="fa fa-close" @click="removeImg(img.src)" /></span>
      <a :href="'api/File/GetFile/' + img.src" target="_blank"><el-image
        style="width: 120px; height: 120px"
        :src="'api/File/GetFile/' + img.src"
        fit="contain"></el-image>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImagePaste',
  model: {
    prop: 'imgs' // ,
    // event: 'change'
  },
  props: {
    autoupload: Boolean,
    uploadpath: String,
    readonly: Boolean,
    imgs: Array // {name: '', src: ''}
  },
  data () {
    return {
      message: '请点击此区域后进行粘贴操作！',
      isFocusable: false,
      originalEvent: {},
      _paste_event_fired: {}
    }
  },
  methods: {
    click () {
      this.$refs.container.focus()
    },
    focus () {
      this.isFocusable = true
    },
    blur () {
      this.isFocusable = false
    },
    paste (ev) {
      if (this.readonly) {
        return null
      }

      var _i, clipboardData, file, item, k, l, len1, len2, pastedFilename, reader, ref2, ref3, ref4
      this.originalEvent = (ev.originalEvent !== null ? ev.originalEvent : null)
      this._paste_event_fired = true
      clipboardData = ev.clipboardData || ev.originalEvent.clipboardData
      if (clipboardData != null) {
        clipboardData = ev.clipboardData || ev.originalEvent.clipboardData
        if (clipboardData.items) {
          pastedFilename = null
          ref2 = clipboardData.items
          for (_i = k = 0, len1 = ref2.length; k < len1; _i = ++k) {
            item = ref2[_i]
            if (item.type.match(/^image\//)) {
              reader = new FileReader()
              reader.onload = (event) => {
                return this.handleImage(event.target.result, this.originalEvent, pastedFilename)
              }
              try {
                reader.readAsDataURL(item.getAsFile())
              } catch (error) {}
              ev.preventDefault()
              break
            }
          }
        } else {
          this.checkImagesInContainer(function(src) {
            return this.handleImage(src, this.originalEvent)
          })
        }
      }
      if ((clipboardData = window.clipboardData) != null) {
        if ((ref3 = clipboardData.getData('Text')) != null ? ref3.length : void 0) {

        } else {
          ref4 = clipboardData.files
          for (l = 0, len2 = ref4.length; l < len2; l++) {
            file = ref4[l]
            this.handleImage(URL.createObjectURL(file), this.originalEvent)
          }
          this.checkImagesInContainer(function(src) {
            return this.handleImage(src, this.originalEvent)
          })
        }
      }
      return null
    },
    handleImage (src, e, name) {
      var loader
      if (src.match(/^webkit-fake-url:\/\//)) {
        this.message = 'You are trying to paste an image in Safari, however we are unable to retieve its data.'
      }
      loader = new Image()
      loader.crossOrigin = 'anonymous'
      loader.onload = () => {
        var blob, canvas, ctx, dataURL
        canvas = document.createElement('canvas')
        canvas.width = loader.width
        canvas.height = loader.height
        ctx = canvas.getContext('2d')
        ctx.drawImage(loader, 0, 0, canvas.width, canvas.height)
        dataURL = null
        try {
          dataURL = canvas.toDataURL('image/jpeg')
          blob = this.dataURLtoBlob(dataURL)
        } catch (error) {}
        if (dataURL) {
          if (this.autoupload) {
            var fd = new FormData()
            fd.append('fileData', blob, '123.jpg')
            // fd.append('fileName', '123.jpg')
            this.$ajax({
              url: 'api/File/UploadFile?path=' + (this.uploadpath ? this.uploadpath : 'WorkItemFile'),
              method: 'post',
              contentType: false,
              processData: false,
              data: fd,
              success: (d) => {
                var img = {name: name, src: d}
                this.imgs.push(img)
                // this.$emit('change', this.imgs)
              }
            })
          }

          this.$emit('pasteimage', {
            blob: blob,
            dataURL: dataURL,
            width: loader.width,
            height: loader.height,
            originalEvent: e,
            name: name
          })
        }
      }
      loader.onerror = () => {
        this.message = 'Failed to get image from: ' + src
      }
      loader.src = src
    },
    checkImagesInContainer (cb) {
      var img, j, len, ref, timespan
      timespan = Math.floor(1000 * Math.random())
      ref = this.$refs.container.getElementsByTagName('img')
      for (j = 0, len = ref.length; j < len; j++) {
        img = ref[j]
        img['_paste_marked_' + timespan] = true
      }
      return setTimeout(function() {
        var k, len1, ref1
        ref1 = this.$refs.container.getElementsByTagName('img')
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          img = ref1[k]
          if (!img['_paste_marked_' + timespan]) {
            cb(img.src)
            this.$refs.container.removeChild(img)
          }
        }
      }, 1)
    },
    dataURLtoBlob (dataURL, sliceSize) {
      var b64Data, byteArray, byteArrays, byteCharacters, byteNumbers, contentType, i, m, offset, ref, slice
      if (sliceSize == null) {
        sliceSize = 512
      }
      if (!(m = dataURL.match(/^data:([^;]+);base64,(.+)$/))) {
        return null
      }
      ref = m
      m = ref[0]
      contentType = ref[1]
      b64Data = ref[2]
      byteCharacters = atob(b64Data)
      byteArrays = []
      offset = 0
      while (offset < byteCharacters.length) {
        slice = byteCharacters.slice(offset, offset + sliceSize)
        byteNumbers = new Array(slice.length)
        i = 0
        while (i < slice.length) {
          byteNumbers[i] = slice.charCodeAt(i)
          i++
        }
        byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
        offset += sliceSize
      }
      return new Blob(byteArrays, {
        type: contentType
      })
    },
    removeImg (imgsrc) {
      this.imgs.splice(this.imgs.findIndex(v => v.src === imgsrc), 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">    
    .pastable{
      transition: box-shadow ease .3s;
    }
    .pastable:hover{
      // box-shadow: 0 0 3px black;
      
      border: 1px solid #409EFF;
      border-radius: 4px;
    }
    .pastable.pastablefocus{
      // box-shadow: 0 0 10px black;
      border: 1px solid #409EFF;
      border-radius: 4px;
    }

    .image-block {
    padding: 10px 0;
    text-align: center;
    border-right: 1px solid #eff2f6;
    display: inline-block;
    width: 20%;
    box-sizing: border-box;
    vertical-align: top;
    
    }
    .fa-close {
      cursor: pointer;      
      padding-right:10px;
    }
</style>